import {Actions, State} from './ResultStory.types';

export type StoryHeaderVariant = 'primary' | 'light' | 'dark';

export const STEPS = [
  {
    autoAdvance: false,
    controlsVariant: 'inverse' as const,
    headerVariant: 'light' as StoryHeaderVariant,
    showControls: false,
    showShare: false,
    name: 'Results Story Landing',
    videoSrcs: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-1st-loop.mp4',
    ],
    videoSrcsDesktop: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-1st-loop.mp4',
    ],
  },
  {
    autoAdvance: false,
    controlsVariant: 'primary' as const,
    headerVariant: 'primary' as StoryHeaderVariant,
    showControls: true,
    showShare: false,
    name: 'Results Story Education',
    videoSrcs: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-1st-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-2nd-loop.mp4',
    ],
    videoSrcsDesktop: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-1st-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-2nd-loop.mp4',
    ],
  },
  {
    autoAdvance: true,
    controlsVariant: 'inverse' as const,
    headerVariant: 'dark' as StoryHeaderVariant,
    showControls: true,
    showShare: false,
    name: '',
    playbackRates: [1, 2.75],
    videoSrcs: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-2nd-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-3rd-loop.mp4',
    ],
    videoSrcsDesktop: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-2nd-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-3rd-loop.mp4',
    ],
  },
  {
    autoAdvance: false,
    controlsVariant: 'inverse' as const,
    headerVariant: 'dark' as StoryHeaderVariant,
    showControls: true,
    showShare: false,
    markAsSeen: true,
    name: 'Results Story TallyAge™',
    videoSrcs: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-3rd-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-4th-loop-contracting.mp4',
    ],
    videoSrcsAlt: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-3rd-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-4th-loop-expanding.mp4',
    ],
    videoSrcsDesktop: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-3rd-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-4th-loop-contracting.mp4',
    ],
    videoSrcsDesktopAlt: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-3rd-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-4th-loop-expanding.mp4',
    ],
  },
  {
    autoAdvance: false,
    controlsVariant: 'inverse' as const,
    headerVariant: 'dark' as StoryHeaderVariant,
    showControls: true,
    showShare: false,
    name: 'Results Story Intro',
    videoSrcs: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-4th-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-5th-loop.mp4',
    ],
    videoSrcsDesktop: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-4th-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-5th-loop.mp4',
    ],
  },
  {
    autoAdvance: false,
    controlsVariant: 'inverse' as const,
    headerVariant: 'dark' as StoryHeaderVariant,
    showControls: true,
    showShare: false,
    name: 'Results Story Compare',
    videoSrcs: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-5th-loop.mp4',
    ],
    videoSrcsDesktop: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-5th-loop.mp4',
    ],
  },
  {
    autoAdvance: false,
    controlsVariant: 'inverse' as const,
    headerVariant: 'dark' as StoryHeaderVariant,
    showControls: true,
    showShare: true,
    name: 'Results Story Share',
    videoSrcs: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-5th-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-6th-loop.mp4',
    ],
    videoSrcsDesktop: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-5th-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-6th-loop.mp4',
    ],
  },
  {
    autoAdvance: false,
    controlsVariant: 'primary' as const,
    headerVariant: 'primary' as StoryHeaderVariant,
    showControls: true,
    showShare: false,
    name: 'Results Story Motivate',
    videoSrcs: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-6th-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-7th-loop.mp4',
    ],
    videoSrcsDesktop: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-6th-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-7th-loop.mp4',
    ],
  },
  {
    autoAdvance: false,
    controlsVariant: 'inverse' as const,
    headerVariant: 'light' as StoryHeaderVariant,
    showControls: false,
    showShare: false,
    name: 'Results Story Upsell',
    videoSrcs: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-7th-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/mobile-8th-loop.mp4',
    ],
    videoSrcsDesktop: [
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-7th-transition.mp4',
      'https://tallyhealth-public-assets-prod.s3.us-west-2.amazonaws.com/video/result-stories/desktop-8th-loop.mp4',
    ],
  },
];

export const VIDEOS_BY_STEP = STEPS.map(({videoSrcs}) => videoSrcs);
export const VIDEOS_BY_STEP_DESKTOP = STEPS.map(({videoSrcsDesktop}) => videoSrcsDesktop);

export const VIDEOS_BY_STEP_ALT = STEPS.map(
  ({videoSrcs, videoSrcsAlt}) => videoSrcsAlt || videoSrcs,
);
export const VIDEOS_BY_STEP_DESKTOP_ALT = STEPS.map(
  ({videoSrcsDesktop, videoSrcsDesktopAlt}) => videoSrcsDesktopAlt || videoSrcsDesktop,
);

export const initialState = {
  activeStep: 0,
  activeVideo: 0,
  controlsDisabled: false,
  loadPercentage: 0,
  useAltVideo: false,
} as State;

/**
 * This is a reducer function that returns the appropriate state values for the
 * ResultsStory page component. A "step" may contain multiple videos, played in
 * sequence. This state reducer tracks both the current step, and which video is
 * currently being played in the current step.
 */
export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case 'DecrementStep': {
      return {
        ...state,
        activeStep: state.activeStep - 1,
        activeVideo: 0,
      };
    }
    case 'DisableControls': {
      return {...state, controlsDisabled: true};
    }
    case 'EnableControls': {
      return {...state, controlsDisabled: false};
    }
    case 'IncrementStep': {
      return {
        ...state,
        activeStep: state.activeStep + 1,
        activeVideo: 0,
      };
    }
    case 'IncrementVideo': {
      const nextVideo = state.activeVideo + 1;
      const activeStepData = STEPS[state.activeStep];
      const desktopVideos = state.useAltVideo ? VIDEOS_BY_STEP_DESKTOP_ALT : VIDEOS_BY_STEP_DESKTOP;
      const mobileVideos = state.useAltVideo ? VIDEOS_BY_STEP_ALT : VIDEOS_BY_STEP;
      const renderedVideoSteps = action.payload.isDesktop ? desktopVideos : mobileVideos;

      if (nextVideo >= renderedVideoSteps[state.activeStep].length) {
        return activeStepData.autoAdvance
          ? {...state, activeStep: state.activeStep + 1, activeVideo: 0}
          : state;
      } else {
        return {...state, activeVideo: nextVideo};
      }
    }
    case 'SetLoadPercentage': {
      return {...state, loadPercentage: action.payload};
    }
    case 'SetAltVideos': {
      return {...state, useAltVideo: action.payload};
    }
    default: {
      return state;
    }
  }
}
